export const defaultEntity = "tipologieOpere";
export const entities = ["tipologieOpere"];
export const labels = {
  tipologieOpere: "Tipologie",
};
